import React from "react";
import config from "Config";
import logo from "Assets/img/geografia_logo.svg";
// import backgroundImage from 'Assets/img/dlgcs_brand_element_banner.svg';
import history from "Services/history";
import { Tooltip } from "reactstrap";
import withState from "recompose/withState";

const STATE = config.admin_state_acronym.toLowerCase();
const client_logo_name =
  STATE === "qld" ? "client_logo.svg" : "client_logo.png";
const ClientLogo = require(`Assets/${STATE}/img/${client_logo_name}`);

const addToolTipState = withState("tooltipOpen", "setTooltipOpen", false);

const Template = ({ tooltipOpen, setTooltipOpen }) => (
  <div
    id="topmenu"
    className="top-menu-bg white align-items-center justify-content-between"
  >
    <div className="mr-auto client_logo">
      <a
        className=""
        href={config.department_url}
        target="_blank"
        rel="noopener"
      >
        <img src={ClientLogo} />
      </a>
    </div>
    <div className="company_logo ml-auto">
      <a
        className="ml-auto"
        target="_blank"
        rel="noopener"
        href="http://geografia.com.au"
      >
        <img src={logo} />
      </a>

      <Tooltip
        placement="left"
        isOpen={tooltipOpen}
        target="TooltipElem"
        toggle={_ => setTooltipOpen(!tooltipOpen)}
      >
        Explanatory Notes
      </Tooltip>

      <span
        style={{ cursor: "pointer" }}
        id="TooltipElem"
        onClick={_ => history.push("/about")}
        className="fa-stack fa "
      >
        <i className="fa fa-circle-thin fa-stack-2x" />
        <i className="fa fa-info fa-stack-1x" />
      </span>
    </div>
  </div>
);

export default addToolTipState(Template);



// WEBPACK FOOTER //
// ./components/TopMenu.js